import advisorProfiles from './advisorProfiles'
import daiOptOuts from './daiOptOuts'
import governanceProjects from './governanceProjects'
import organizationCompanies from './organizationCompanies'
import organizations from './organizations'
import organizationUsers from './organizationUsers'
import userProfiles from './userProfiles'
import users from './users'

const backoffice = {
  advisorProfiles,
  daiOptOuts,
  governanceProjects,
  organizationCompanies,
  organizations,
  organizationUsers,
  userProfiles,
  users,
}

export default backoffice
